import React, {  } from 'react';

import { dateTimeFormatOptions } from '../types';
import { DateTimeFormatInput, DatTimeFormatRuleSet } from './Intl.DateTimeFormat';
import { IntlFunction } from './Intl.Function';

export const IntlDateTimeFormatFormat = () => (
	<IntlFunction
		input={DateTimeFormatInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format"
		header="Intl.DateTimeFormat.prototype.format"
		description="Formats a date according to the **`locale`** and formatting **`options`** of this [Intl.DateTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) object."
		options={dateTimeFormatOptions}
		ruleSet={DatTimeFormatRuleSet}
		template="new Intl.DateTimeFormat(##locale##, ##options##).format(##input:raw##)" />
)